module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('h1', [_vm._v("Two Factor Authentication")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Enter the pin from Google Authenticator app:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeFromGoogle),
      expression: "codeFromGoogle"
    }],
    ref: "codeInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "One Time Password"
    },
    domProps: {
      "value": (_vm.codeFromGoogle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeFromGoogle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                    Login\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])])]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-envelope"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f57308","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/unauthorizedPages/TwoFactorAuthentication.vue
// module id = 870
// module chunks = 0